import Auth from '../modules/Authentication'
import { apiUrl } from '../variables'
import { handleErrors, handleResponse } from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
const auth = new Auth()

export const SupportApi = {
  list: () => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}support`, { headers }).then(handleErrors).then(handleResponse)
  },
  read: (key) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}support/${key}`, { headers }).then(handleErrors).then(handleResponse)
  },
  create: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}support/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  update: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}support/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  remove: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}support/`, {
      headers: headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },

  operation: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}support/action`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
}
